import React from "react";
import HomeVerticalProgress from "../components/HomeVerticalProgress";
import DashboardFooterCards from "../components/DashboardFooterCards";
import HomeProgressStepSection from "../components/HomeProgressStepSection";
import useOnboardingSteps from "../hooks/useOnboardingSteps";

const Home = () => {
  const { progress } = useOnboardingSteps();

  return (
    <div className="p-4 sm:p-8 flex flex-col gap-8 max-w-7xl m-auto">
      <div className="text-center sm:text-left">
        <div className="hidden sm:block">
          <img src="/icon.svg" alt="Logo" className="h-11" />
        </div>

        <h1 className="leading-loose font-semibold text-2xl p-0 m-0 sm:mt-0 mt-6 text-gray-900">
          Get started with SupportMagic
        </h1>

        <h2 className="text-gray-600 p-0 m-0 text-base font-normal leading-normal">
          Complete these steps to set up and start automating your customer
          support like a pro.
        </h2>
      </div>
      <div className="flex items-center gap-4">
        <div className="overflow-hidden rounded-full bg-gray-200 flex-1">
          <div
            style={{ width: progress }}
            className="h-2 rounded-full bg-customGreen transition-all"
          />
        </div>

        <span className="text-xs font-semibold">{progress}</span>
      </div>
      <div className="flex sm:items-start gap-6 flex-col-reverse sm:flex-row">
        <div className="flex-1 sm:max-w-md border rounded-2xl px-6 py-4">
          <HomeVerticalProgress />
        </div>

        <div className="flex-1">
          <HomeProgressStepSection />
        </div>
      </div>
      <div className="w-full border-b sm:block hidden" />
      <DashboardFooterCards />
    </div>
  );
};

export default Home;
